export class FilterModel {

  uid: number;
  name: string;
  singleLineAddress: string;
  code: string;
  selected: boolean;
  organisationUid: number;

  constructor() {

  }
}